import { render } from "./ImgView.vue?vue&type=template&id=5d4aba2b&scoped=true"
import script from "./ImgView.vue?vue&type=script&lang=js"
export * from "./ImgView.vue?vue&type=script&lang=js"

import "./ImgView.vue?vue&type=style&index=0&id=5d4aba2b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4aba2b"]])

export default __exports__